/*!
 * SlideshowView - Vue diaporama héritant de ThumbnailsView pour IconsView
 */

import ThumbnailsView from './ThumbnailsView';

export default class SlideshowView extends ThumbnailsView {
    constructor(plugin) {
        super(plugin, 'slideshow');
    }

    createContainer(element) {
        const myself = this.plugin;
        this.container = $('<div></div>');
        myself.container = this.container;
        myself.preview = $('<div class="iv__preview private"></div>');

        if (myself.options && myself.options.event && myself.options.event.leftClick !== 'select1') {
            myself.options.event.backup = clone(myself.options.event);
            myself.options.event.doubleClick = myself.options.event.leftClick;
            myself.options.event.leftClick = 'select1';
        }

        myself.containerView.addClass('iv__view iv__view--slideshow view view-slideshow');
        element.append(this.container);
        if (myself.preview) {
            element.append(myself.preview);
        }

        return this.container;
    }

    postCreateContainer() {
        if (typeof this.plugin.preloadPreviewPane === 'function') {
            this.plugin.preloadPreviewPane();
        }
    }
}
